import { apiRequest } from "../utils/useAPIRequest";
import constant from "../utils/constant";
import { supportStore } from "../stores";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { queryClient } from "../App";

const useGetSupports = (supportsTableQuery, filterQuery, searchQuery) => {
  const query = useMemo(() => {
    if (searchQuery && filterQuery) {
      return `${supportsTableQuery}&${filterQuery}&search=${searchQuery}`;
    } else if (searchQuery) {
      return `${supportsTableQuery}&search=${searchQuery}`;
    } else if (filterQuery) {
      return `${supportsTableQuery}&${filterQuery}`;
    } else {
      return supportsTableQuery;
    }
  }, [filterQuery, supportsTableQuery, searchQuery]);

  return useQuery({
    queryKey: ["getSupports", query],
    queryFn: () => {
      return apiRequest({
        url: `/supports?${query}`,
        method: "get",
      });
    },
    keepPreviousData: true,
  });
};

const getFaqs = async (id) => {
  const { status, errorMessage, data } = await apiRequest({
    url: "/supports/faq/categories",
    method: "get",
  });

  if (status === constant.Success) {
    supportStore.setFaqs(data.faqs);
    return { status };
  }
  return { status, errorMessage };
};

const createFaq = async (payload) => {
  const { status, errorMessage } = await apiRequest({
    url: "/supports/faq",
    method: "post",
    payload: payload,
  });
  if (status === constant.Success) {
    await getFaqs();
    return { status };
  }
  return { status, errorMessage };
};

const createFaqCategory = async (payload) => {
  const { status, errorMessage } = await apiRequest({
    url: "/supports/faq/category",
    method: "post",
    payload: payload,
  });
  if (status === constant.Success) {
    await getFaqs();
    return { status };
  }
  return { status, errorMessage };
};
const createSupport = async (payload) => {
  const { status, errorMessage } = await apiRequest({
    url: "/supports",
    method: "post",
    payload,
    hasImageUpload: true,
  });
  if (status === constant.Success) {
    queryClient.invalidateQueries({
      queryKey: ["getSupports"],
    });
    return { status };
  }
  return { status, errorMessage };
};

// const createSupport = async payload =>
// 	await apiRequest({ url: '/supports', method: 'post', payload });

const editFaq = async (payload, id) => {
  const { status, errorMessage } = await apiRequest({
    url: `/supports/faq/${id}`,
    method: "patch",
    payload: payload,
  });

  if (status === constant.Success) {
    await getFaqs();
    return { status };
  }
  return { status, errorMessage };
};
const updateSupport = async (payload, supportID) => {
  const { status, errorMessage } = await apiRequest({
    url: `/supports/support/${supportID}`,
    method: "patch",
    payload: payload,
  });

  if (status === constant.Success) {
    queryClient.invalidateQueries({
      queryKey: ["getSupports"],
    });
    return { status };
  }
  return { status, errorMessage };
};
const editFaqCategory = async (payload, id) => {
  const { status, errorMessage } = await apiRequest({
    url: `/supports/faq/category/${id}`,
    method: "patch",
    payload: payload,
  });

  if (status === constant.Success) {
    await getFaqs();
    return { status };
  }
  return { status, errorMessage };
};

const deleteFaq = async (id) => {
  const { status, errorMessage, data } = await apiRequest({
    url: `/supports/faq/${id}`,
    method: "delete",
  });

  if (status === constant.Success) {
    supportStore.setFaqs(data.faqs);
    await getFaqs();
    return { status };
  }
  return { status, errorMessage };
};

const deleteFaqCategory = async (id) => {
  const { status, errorMessage } = await apiRequest({
    url: `/supports/faq/category/${id}`,
    method: "delete",
  });
  if (status === constant.Success) {
    await getFaqs();
    return { status };
  }
  return { status, errorMessage };
};

export default {
  useGetSupports,
  getFaqs,
  createFaq,
  editFaq,
  editFaqCategory,
  deleteFaq,
  deleteFaqCategory,
  createFaqCategory,
  updateSupport,
  createSupport,
};
